import React, { JSX } from 'react';

import { IInventoryRule, InventoryRuleType } from '~/src/dash/apiV2/inventory-rules/inventoryRules';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { Col, Cols, Row, Rows, spacing, Text, usePublicaTranslation } from '~/src/dash/publicaUI';
import { formatDateTimeUnchanged } from '~/src/dash/utils/date';
import {
  convertResponseTypeToTKey,
  convertRuleTypeToTKey,
  convertTimezoneTypeToTKey,
} from '~/src/dash/views/inventory-rules-v2/common';
import { ColKeyValuePair } from '~/src/dash/views/inventory-rules-v2/Rules/InventoryRulesList/InventoryRuleDrawer/ColKeyValuePair';
interface IProps {
  rule: IInventoryRule;
}

export const InventoryRuleOverview = ({ rule }: IProps): JSX.Element => {
  const { t } = usePublicaTranslation();

  const {
    Name,
    RuleType,
    LookupKey,
    LookupValue,
    ResponseType,
    TimezoneType,
    StartDateTime,
    EndDateTime,
  } = rule;
  return (
    <Rows gap={spacing.small}>
      <Row noPadding>
        <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
          <Col displayFlex>
            <IconV2 name='checkmark-plain' small />
          </Col>
          <Col>
            <Text small bold tKey='Overview' singleLineLabel />
          </Col>
        </Cols>
      </Row>
      <Row largeHorizontalPadding noVerticalPadding>
        <Cols
          wrap
          gap={spacing.medium}
          style={{
            alignItems: 'flex-start',
          }}
        >
          {/* Overview fields - only render if value exists */}
          {Name && <ColKeyValuePair tKey='Name' value={Name} />}
          {RuleType !== undefined && (
            <ColKeyValuePair tKey='FormatType' value={t(convertRuleTypeToTKey(RuleType))} />
          )}
          {LookupKey && <ColKeyValuePair tKey='Key' value={LookupKey} />}
          {LookupValue && <ColKeyValuePair tKey='Value' value={LookupValue} />}
          {RuleType === InventoryRuleType.VMAP && ResponseType !== undefined && (
            <ColKeyValuePair
              tKey='VMAPResponseType'
              value={t(convertResponseTypeToTKey(ResponseType))}
            />
          )}
          {TimezoneType !== undefined && (
            <ColKeyValuePair
              tKey='TimezoneType'
              value={t(convertTimezoneTypeToTKey(TimezoneType))}
            />
          )}
          {StartDateTime && (
            <ColKeyValuePair tKey='StartTime' value={formatDateTimeUnchanged(StartDateTime)} />
          )}
          {EndDateTime && (
            <ColKeyValuePair tKey='EndTime' value={formatDateTimeUnchanged(EndDateTime)} />
          )}
        </Cols>
      </Row>
    </Rows>
  );
};
